module.exports = __webpack_public_path__ + "assets/img/8.39d341c8.png";